import React from 'react'
import { Container } from './styles'
import { IconComponent } from '~/assets/icons/component'
export const NotFound = (): JSX.Element => {
  return (
    <Container>
      <IconComponent name="notFound" />
      <h1>Nenhum resultado encontrado</h1>
      <span>{`Este paciente não possui eventos cadastrados\nou não foi possível recuperá-los em nossa base.`}</span>
    </Container>
  )
}
